import MultiCascadeTree from './MultiCascadeTree';

// export types
export type { Option } from '@/internals/types';
export type { MultiCascadeTreeProps } from './types';

// export components
export { MultiCascadeTree };
export default MultiCascadeTree;
